import React, { useMemo } from 'react';
import { cssTransition, ToastContainer } from 'react-toastify';
import styles from "./Toast.module.js";
import "./Toaster.css";
import { jsx as _jsx } from "react/jsx-runtime";
export const Toaster = ({
  className
}) => {
  const InFromTopOutSideways = useMemo(() => {
    return cssTransition({
      enter: styles.toastAnimationEnter,
      exit: styles.toastAnimationExit,
      duration: 300
    });
  }, []);
  return /*#__PURE__*/_jsx(ToastContainer, {
    className: className,
    position: "top-center",
    transition: InFromTopOutSideways,
    closeButton: false,
    hideProgressBar: true,
    closeOnClick: false,
    pauseOnHover: true
  });
};